import React from "react"
import BookMeetProvider from "../../bookMeet/bookMeetContext"
import BookMeetModal from "../../bookMeet/bookMeetModal"
import { getUserFromMeetLink } from "../../../library/store/actions/creators/authCreators"
import useCreator from "../../../hooks/useCreator"
import { useParams } from "react-router-dom"
import Loader from "../../../components/ui/loader"

const CreateMeetAsGuest = () => {
  return (
    <BookMeetProvider>
      <BookMeetModal />
    </BookMeetProvider>
  )
}

export default CreateMeetAsGuest
